import { mapGetters, mapActions } from 'vuex'
import {
  commonUtil,
  countryUtil,
  currencyUtil,
  countryCallingCodeUtil
} from '@/util'
import {
  ExpansionPanel,
  InputFormNew,
  PhoneNumberInput,
  PostalCodeArea,
  SelectSuggestedReceivingLocation
} from '@/components/items'

import detail from './detail'

export default {
  components: {
    ExpansionPanel,
    InputFormNew,
    PhoneNumberInput,
    PostalCodeArea,
    SelectSuggestedReceivingLocation
  },
  props: {
    clientInfo: {}
  },
  data: () => {
    return {
      isEdit: { default: false },

      // Design
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 3,
        contentsCols: 12 - 3,
        inputItemHeight: '32px'
      },
      clientDetail: detail.detail,

      clientData: {
        clientInfo: {},

        invoiceInfo: {
          supplierName: '',
          section: '',
          rep: '',
          phone: {
            countryCode: {},
            phoneNumber: ''
          },
          fax: {
            countryCode: {},
            phoneNumber: ''
          },
          email: '',
          country: {},
          postalCode: '',
          region: { label: '', value: null },
          address1: '',
          address2: ''
        },
        receiverInfo: {
          receiverName: {},
          phone: {
            countryCode: {},
            phoneNumber: ''
          },
          country: {},
          postalCode: '',
          region: { label: '', value: null },
          address1: '',
          address2: ''
        },
        orderInfo: {
          currency: {},
          orderDate: commonUtil.getToday(),
          deliveryDate: commonUtil.getToday()
        }
      },

      // 受取人情報
      recipientList: [],
      recipientNameList: []
    }
  },
  async created() {
    this.setIsLoading(true)
    await this.getSuggestedReceivingLocationListFromApi()
    this.recipientNameList =
      this.getSuggestedReceivingLocationListFromState().map((ele) => {
        return {
          value: ele.suggestedReceivingLocationId,
          label: ele.location
        }
      })

    this.getClientData()
    this.setIsLoading(false)
  },
  methods: {
    ...mapGetters('Common', [
      'getCountryListFromState',
      'getCountryCallingCodeJpFromState',
      'getCountryJpFromState',
      'getCurrencyJpFromState'
    ]),
    ...mapActions('Common', ['setIsLoading']),
    ...mapActions('Supplier', ['getSuggestedReceivingLocationListFromApi']),
    ...mapGetters('Supplier', ['getSuggestedReceivingLocationListFromState']),

    getClientData() {
      ;[this.clientData.orderInfo].map((ele) => {
        ele.orderDate = commonUtil.getToday()
        ele.deliveryDate = commonUtil.getToday()
      })
      ;[this.clientData.orderInfo].map((ele) => {
        ele.currency = this.getCurrencyJpFromState()
      })

      if (!Object.keys(this.clientInfo).length) {
        ;[
          this.clientData.invoiceInfo.phone,
          this.clientData.invoiceInfo.fax,
          this.clientData.receiverInfo.phone
        ].map((ele) => {
          ele.countryCode = this.getCountryCallingCodeJpFromState()
        })
        ;[this.clientData.invoiceInfo, this.clientData.receiverInfo].map(
          (ele) => {
            ele.country = this.getCountryJpFromState()
          }
        )
        return
      }

      this.isEdit = 'orderId' in this.clientInfo

      this.setCtomerData()
    },
    setCtomerData() {
      const clientInfoTmp = { ...this.clientInfo }

      this.clientData = {
        clientInfo: this.isEdit ? clientInfoTmp.supplier : clientInfoTmp,
        invoiceInfo: this.setinvoiceInfo(clientInfoTmp),
        receiverInfo: this.setInitReceiverInfo(clientInfoTmp),
        orderInfo: this.setOrderInfo(clientInfoTmp, {
          ...this.clientData.orderInfo
        })
      }
    },

    formatInvoiceInfo(propertyName) {
      const identifier = this.isEdit ? 'order' : ''

      return identifier
        ? identifier +
            propertyName.slice(0, 1).toUpperCase() +
            propertyName.slice(1)
        : propertyName
    },
    setinvoiceInfo(list) {
      return {
        supplierName: this.isEdit ? list.orderSupplierName : list.name,
        section: list[this.formatInvoiceInfo('section')],
        rep: this.isEdit ? list.orderPerson : list.rep,
        phone: {
          countryCode: countryCallingCodeUtil.getPhoneNumberInfoById(
            list[this.formatInvoiceInfo('phoneNumberCountryId')]
          ),
          phoneNumber: list[this.formatInvoiceInfo('phoneNumber')]
        },
        fax: {
          countryCode: countryCallingCodeUtil.getPhoneNumberInfoById(
            list[this.formatInvoiceInfo('faxNumberCountryId')]
          ),
          phoneNumber: this.isEdit ? list.orderFax : list.faxNumber
        },
        email: list[this.formatInvoiceInfo('email')],
        country: countryUtil.getCountryIdInfo(
          list[this.formatInvoiceInfo('addressCountryId')]
        ),
        postalCode: this.isEdit ? list.orderPostcode : list.postalCode,
        region: countryUtil.getRegionInfo(
          list[this.formatInvoiceInfo('addressCountryId')],
          list[this.formatInvoiceInfo('regionId')]
        ),
        address1: list[this.formatInvoiceInfo('address1')],
        address2: list[this.formatInvoiceInfo('address2')]
      }
    },
    setInitReceiverInfo(list) {
      const recipients = this.getSuggestedReceivingLocationListFromState()
      const receiver =
        recipients.length && list.suggestedReceivingLocationId
          ? recipients.find(
              (ele) =>
                ele.suggestedReceivingLocationId ===
                list.suggestedReceivingLocationId
            )
          : {}

      if (!this.isEdit && !recipients.length) {
        return {
          receiverName: { label: '', value: null },
          phone: {
            countryCode: this.getCountryCallingCodeJpFromState(),
            phoneNumber: ''
          },
          country: this.getCountryJpFromState(),
          postalCode: '',
          region: { label: '', value: null },
          address1: '',
          address2: ''
        }
      }

      const listTmp = this.isEdit ? list : receiver
      return this.setReceiverInfo(listTmp)
    },
    formatReceiverInfo(propertyName) {
      const identifier = this.isEdit ? 'preferred' : ''

      return identifier
        ? identifier +
            propertyName.slice(0, 1).toUpperCase() +
            propertyName.slice(1)
        : propertyName
    },
    setReceiverInfo(list) {
      const ret = {
        receiverName: (list && this.getRecipientNameObj(list)) || {
          label: '',
          value: null
        },

        phone: {
          countryCode:
            (list &&
              countryCallingCodeUtil.getPhoneNumberCountryIdInfo(
                list[this.formatReceiverInfo('phoneNumberCountryId')]
              )) ||
            this.getCountryCallingCodeJpFromState(),
          phoneNumber:
            (list && list[this.formatReceiverInfo('phoneNumber')]) || ''
        },
        country:
          (list &&
            countryUtil.getCountryIdInfo(
              list[this.formatReceiverInfo('addressCountryId')]
            )) ||
          this.getCountryJpFromState(),
        postalCode: (list && list[this.formatReceiverInfo('postalCode')]) || '',
        region: (list &&
          countryUtil.getRegionInfo(
            list[this.formatReceiverInfo('addressCountryId')],
            list[this.formatReceiverInfo('regionId')]
          )) || { label: '', value: null },
        address1: (list && list[this.formatReceiverInfo('address1')]) || '',
        address2: (list && list[this.formatReceiverInfo('address2')]) || ''
      }

      return ret
    },
    setOrderInfo(list, orderInfo) {
      return {
        currency: this.isEdit
          ? currencyUtil.getCurrencyIdInfo(list.currencyId)
          : orderInfo.currency,
        orderDate: this.isEdit ? list.orderDate : orderInfo.orderDate,
        deliveryDate: orderInfo.deliveryDate
      }
    },

    onClickPostalCodeInvoiceInfo(...args) {
      const [address] = args
      this.setPostalCode(address, 'invoiceInfo')
    },
    onClickPostalCodeReceiverInfo(...args) {
      const [address] = args
      this.setPostalCode(address, 'receiverInfo')
    },
    setPostalCode(address, infoName) {
      this.clientData[infoName].region = countryUtil.getRegionInfoByName(
        this.clientData[infoName].country.value,
        address.region
      )
      this.clientData[infoName].address1 = address.locality
      this.clientData[infoName].address2 = address.street
    },

    receiverChange(newValue) {
      const storage = this.isEdit
      this.isEdit = false
      this.clientData.receiverInfo = this.setReceiverInfo(
        this.getSuggestedReceivingLocationListFromState().find(
          (ele) => ele.suggestedReceivingLocationId === newValue.value
        )
      )
      this.isEdit = storage
    },
    getRecipientNameObj(rec) {
      return { label: rec.location, value: rec.suggestedReceivingLocationId }
    }
  },

  watch: {
    clientInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.getClientData()
      }
    },
    clientData: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('change', newVal)
      }
    }
  }
}
